export default function camelCase(str) {
  return str
    .toLowerCase() // Converte toda a string para minúsculas
    .split(' ') // Divide a string em um array de palavras
    .map((word, index) => {
      if (index === 0) {
        return word // A primeira palavra permanece em minúsculas
      }
      return word.charAt(0).toUpperCase() + word.slice(1) // As outras começam com maiúscula
    })
    .join('') // Junta as palavras sem espaços
}
